import { AppDownloadSection, PromotionalOffer } from "@/types/landing";

import api from "../api";

// Promotional Offers
export const fetchPromotionalOffers = async (): Promise<PromotionalOffer[]> => {
  const res = await api.get("/promotional-offers");
  const offers = Array.isArray(res.data.offers) ? res.data.offers : [];
  return offers.map((offer: any, idx: number) => ({
    backgroundColor: offer.background_color,
    description: offer.description,
    id: offer.id?.toString() ?? `${idx}`,
    imageAlt: offer.image_alt,
    imageUrl:
      offer.image_url ||
      (offer.image_path
        ? `${import.meta.env.VITE_API_STORAGE_URL}/storage/${offer.image_path}`
        : ""),
    isActive: !offer.hidden,
    order: idx,
    promoCode: offer.promo_code,
    subtitle: offer.subtitle,
    title: offer.title,
  }));
};

export const addPromotionalOffer = async (
  data: FormData | PromotionalOffer,
) => {
  return api.post("/promotional-offers", data);
};

export const updatePromotionalOffer = async (
  id: string,
  data: FormData | PromotionalOffer,
) => {
  return api.post(`/promotional-offers/${id}`, data);
};

export const hidePromotionalOffer = async (id: string) => {
  return api.post(`/promotional-offers/${id}/hide`);
};

export const unhidePromotionalOffer = async (id: string) => {
  return api.post(`/promotional-offers/${id}/unhide`);
};

export const deletePromotionalOffer = async (id: string) => {
  return api.delete(`/promotional-offers/${id}`);
};

// App Download Section
export const fetchAppDownloadSection =
  async (): Promise<AppDownloadSection | null> => {
    const res = await api.get("/app-download-section");
    const section = res.data?.section;
    if (!section) return null;
    return {
      androidUrl: section.android_url || "",
      appGalleryUrl: section.app_gallery_url || undefined,
      backgroundColor: section.background_style || "#222",
      description: section.description || "",
      id: section.id?.toString() ?? "0",
      iosUrl: section.ios_url || "",
      isActive:
        section.show_on_landing === "1" || section.show_on_landing === 1,
      phoneImageAlt: section.image_alt || "",
      phoneImageUrl: section.image_path
        ? `${import.meta.env.VITE_API_STORAGE_URL}/storage/${section.image_path}`
        : "",
      title: section.section_title || "",
      webUrl: section.web_url || undefined,
    };
  };

export const addAppDownloadSection = async (
  data: AppDownloadSection | FormData,
) => {
  return api.post("/app-download-section", data);
};

export const updateAppDownloadSection = async (
  id: string,
  data: AppDownloadSection | FormData,
) => {
  return api.post(`/app-download-section/${id}`, data);
};

// Fetch Transport App Download Section
export const fetchTransportAppDownloadSection =
  async (): Promise<AppDownloadSection | null> => {
    const res = await api.get("/app-download-section?type=transport");
    const section = res.data?.section;
    if (!section) return null;
    return {
      androidUrl: section.android_url || "",
      appGalleryUrl: section.app_gallery_url || undefined,
      backgroundColor: section.background_style || "#222",
      description: section.description || "",
      id: section.id?.toString() ?? "0",
      iosUrl: section.ios_url || "",
      isActive:
        section.show_on_landing === "1" || section.show_on_landing === 1,
      phoneImageAlt: section.image_alt || "",
      phoneImageUrl: section.image_path
        ? `${import.meta.env.VITE_API_STORAGE_URL}/storage/${section.image_path}`
        : "",
      title: section.section_title || "",
      webUrl: section.web_url || undefined,
    };
  };

// Featured Restaurants (Mixed Menu Items)
export const fetchFeaturedRestaurants = async () => {
  const res = await api.get("/menu-items/available-mixed");
  return Array.isArray(res.data.items) ? res.data.items : [];
};
